import React, { useEffect, useState, useCallback } from 'react';
import { Col, Container, Form, Row, Button, Spinner } from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import useAutosave from '../../../hooks/useAutosave';
import typeBoxData from '../../../database/typeBox.json'
import bodyworkData from '../../../database/bodywork.json'
import paintTypeData from '../../../database/paintType.json'
import CertificarPanel from './form.certificar';

// Comparte endpoint con otros formularios de cabecera; scope propio para que
// dos peritos puedan editarlos simultáneamente.
const SCOPE = 'header:vehicle';

function FormInfoVehicle({ id }) {
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [emailBtnMsg, setEmailBtnMsg] = useState('Enviar Correo');
  const [emailBtnVariant, setEmailBtnVariant] = useState('outline-primary');
  const [data, setData] = useState({
    servicevehicle: [],
    vehicletype: [],
    fueltype: [],
    brand: []
  });
  // La placa vive en los datos generales; se lee aparte para no meterla en el
  // cuerpo del guardado de este formulario.
  const [placa, setPlaca] = useState('');
  const [infoFormClient, setInfoFormClient] = useState({
    vehicleType: '',
    brand: '',
    bodywork: '',
    model: '',
    nationality: '',
    typeBox: '',
    cylinderCapacity: '',
    owner: '',
    fueltype: '',
    paintType: '',
    servicevehicle: '',
    mileage: '',
    color: '',
    chassisNumber: '',
    serialNumber: '',
    motorNumber: '',
    id_number: '',
    line: '',
    chassisMarking: '',
    serialMarking: '',
    motorMarking: '',
  });
  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/header/' + id, { ...infoFormClient, scope: SCOPE });
  });

  const handleForm = ({ target }) => {
    setInfoFormClient({ ...infoFormClient, [target.name]: target.value });
    autosave.schedule();
    //generalUpdate(target.name, target.value);
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { ...infoFormClient, scope: SCOPE };
    const respo = await post('/peritaje/modifyinspection/header/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  // Función initForm movida fuera del useEffect para poder ser llamada desde extractInfo
  const initForm = useCallback(async () => {
    const respo = await get('/peritaje/infoinspection/' + id, {});
    if (respo.success) {
      setPlaca(respo.data.placa || '');
      setInfoFormClient({
        vehicleType: respo.data.vehicleType,
        brand: respo.data.brand,
        bodywork: respo.data.bodywork,
        model: respo.data.model,
        nationality: respo.data.nationality,
        typeBox: respo.data.typeBox,
        cylinderCapacity: respo.data.cylinderCapacity,
        owner: respo.data.owner,
        fueltype: respo.data.fueltype,
        paintType: respo.data.paintType,
        servicevehicle: respo.data.servicevehicle,
        mileage: respo.data.mileage,
        color: respo.data.color,
        chassisNumber: respo.data.chassisNumber,
        serialNumber: respo.data.serialNumber,
        motorNumber: respo.data.motorNumber,
        id_number: respo.data.id_number,
        line: respo.data.line,
        chassisMarking: respo.data.chassisMarking,
        serialMarking: respo.data.serialMarking,
        motorMarking: respo.data.motorMarking,
      });
    }
  }, [id]);

  const sendServiceEmail = async () => {
    setIsEmailLoading(true);
    setEmailBtnVariant('outline-primary');
    setEmailBtnMsg('Enviando...');
    try {
      const respo = await post('/notify/send-service-email/' + id, {});
      if (respo.success) {
        setEmailBtnVariant('success');
        setEmailBtnMsg('Correo Enviado');
      } else {
        setEmailBtnVariant('danger');
        setEmailBtnMsg('Error - Reintentar');
      }
    } catch (error) {
      console.error('Error al enviar correo:', error);
      setEmailBtnVariant('danger');
      setEmailBtnMsg('Error - Reintentar');
    } finally {
      setIsEmailLoading(false);
    }
  };

  // Endpoint: /api/ocr/property-card/<id_inspection>/

  const extractInfo = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const respo = await get('/peritaje/ocr/property-card/' + id, {});

      if (respo.success) {
        await initForm();
      }
    } catch (error) {
      console.error('Error al extraer información:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInfoBase();
    initForm();
  }, [id, initForm]);

  const getInfoBase = async () => {
    const respoInfo = await get('/peritaje/infovehicleinspection/', {});
    if (respoInfo.success) {
      setData(respoInfo.data);
    } else {
      console.log(respoInfo.message);
    }
  };
  return (
    <Container>
      <CertificarPanel id={id} placa={placa} />
      <Form id='formgeneralinfo' onSubmit={(e) => sendInfo(e)}>
        <Row className="mb-1">
          <Col>
            <h1 className="fw-bold">Informacion Vehículo</h1>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button
              variant="outline-primary"
              onClick={(e) => extractInfo(e)}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Extrayendo...
                </>
              ) : (
                'Extraer Información'
              )}
            </Button>
          </Col>
        </Row>
        <hr style={{ opacity: 0.1 }} />
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="vehicleType">Tipo</Form.Label>
            <Form.Select
              name="vehicleType"
              value={infoFormClient.vehicleType}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {data.vehicletype.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="brand">Marca</Form.Label>
            <Form.Control
              list="ice-cream-flavors"
              type="text"
              name="brand"
              value={infoFormClient.brand}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
            <datalist id="ice-cream-flavors">
              {
                data.brand.map((element, i) => <option key={i} value={element}>{element}</option>)
              }
            </datalist>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="bodywork">Carroceria</Form.Label>
            <Form.Select
              name="bodywork"
              value={infoFormClient.bodywork}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {bodyworkData.map((element, i) => {
                return (
                  <option key={i} value={element.name}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="model">Modelo</Form.Label>
            <Form.Control
              type="text"
              name="model"
              value={infoFormClient.model}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="nationality">Nacionalidad</Form.Label>
            <Form.Control
              type="text"
              name="nationality"
              value={infoFormClient.nationality}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="typeBox">Tipo Caja</Form.Label>
            <Form.Select
              name="typeBox"
              value={infoFormClient.typeBox}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {typeBoxData.map((element, i) => {
                return (
                  <option key={i} value={element.name}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="cylinderCapacity">Cilindraje</Form.Label>
            <Form.Control
              type="text"
              name="cylinderCapacity"
              value={infoFormClient.cylinderCapacity}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="owner">Propietario</Form.Label>
            <Form.Control
              type="text"
              name="owner"
              value={infoFormClient.owner}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="fueltype">Combustible</Form.Label>
            <Form.Select
              name="fueltype"
              value={infoFormClient.fueltype}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {data.fueltype.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="paintType">Tipo de pintura</Form.Label>
            <Form.Select
              name="paintType"
              value={infoFormClient.paintType}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {paintTypeData.map((element, i) => {
                return (
                  <option key={i} value={element.name}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="servicevehicle">Servicio</Form.Label>
            <Form.Select
              name="servicevehicle"
              value={infoFormClient.servicevehicle}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              {data.servicevehicle.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="mileage">Kilometraje</Form.Label>
            <Form.Control
              type="number"
              name="mileage"
              value={infoFormClient.mileage}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="color">Color</Form.Label>
            <Form.Control
              type="text"
              name="color"
              value={infoFormClient.color}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="chassisNumber">No Chasis</Form.Label>
            <Form.Control
              type="text"
              name="chassisNumber"
              value={infoFormClient.chassisNumber}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="serialNumber">No Serial</Form.Label>
            <Form.Control
              type="text"
              name="serialNumber"
              value={infoFormClient.serialNumber}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="motorNumber">No Motor</Form.Label>
            <Form.Control
              type="text"
              name="motorNumber"
              value={infoFormClient.motorNumber}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="id_number">No Cedula</Form.Label>
            <Form.Control
              type="text"
              name="id_number"
              value={infoFormClient.id_number}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="line">Linea</Form.Label>
            <Form.Control
              type="text"
              name="line"
              value={infoFormClient.line}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              disabled={isLoading}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="chassisMarking">Regrabacion Chasis</Form.Label>
            <Form.Select
              name="chassisMarking"
              value={infoFormClient.chassisMarking}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              <option value="SI">SI</option>
              <option value="No">NO</option>
            </Form.Select>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="serialMarking">Regrabacion Motor</Form.Label>
            <Form.Select
              name="serialMarking"
              value={infoFormClient.serialMarking}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              <option value="SI">SI</option>
              <option value="No">NO</option>
            </Form.Select>
          </Col>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="motorMarking">Regrabacion Serie</Form.Label>
            <Form.Select
              name="motorMarking"
              value={infoFormClient.motorMarking}
              onChange={(e) => handleForm(e)}
              className="fw-bold text-uppercase"
              aria-label="Default select example"
              disabled={isLoading}
              required
            >
              <option value="">Seleccione</option>
              <option value="SI">SI</option>
              <option value="No">NO</option>
            </Form.Select>
          </Col>
        </Row>
        <Row className="my-3">
          <Col className="d-flex justify-content-start">
            <Button
              variant={emailBtnVariant}
              onClick={sendServiceEmail}
              disabled={isEmailLoading}
            >
              {emailBtnMsg}
            </Button>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button type="submit" variant="primary" disabled={isLoading}>
              {msgButton}
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default FormInfoVehicle;